import React, { useEffect, useState } from "react";

import StatisticsCard from "./statistics-card";
import Customer from "./customer";
import Navbar from "../../components/layout/navbar";
import AddCustomerDialog from "../../components/customers/add-customer-dialog";
import useRequest from "../../components/hooks/use-request";
import { Plus } from "lucide-react";
import Button from "../../components/button";
import Pagination from "../../components/pagination";

interface ProfileData {
  username: string;
  email: string;
  phone: string;
  address: string;
  lastLogin: string;
}

interface CustomerData {
  _id: string;
  contactName: string;
  email: string;
  contactNumber: string;
  accountType: string;
  totalOrders: number;
  totalSpent: number;
  createdAt: string;
  isActive: boolean;
}

interface MetricsData {
  newThisMonth: number;
  totalB2bCustomer: number;
  totalB2cCustomer: number;
  totalCustomer: number;
}


const Customers = () => {
  const [profile, setProfile] = useState<ProfileData | null>(null);
  const [customer, setCustomer] = useState<CustomerData | null>(null);
  const [metrics, setMetrics] = useState<MetricsData | null>(null);
  const [customerModal, setCustomerModal] = useState(false);
    const params = new URLSearchParams(new URL(window.location.href).search);
    const [currentPage, setCurrentPage] = useState(
      Number(params.get("page") || 1)
    );
    const [totalPages, setTotalPages] = useState<number>(1);
    const itemsPerPage = 10;
  const userToken = localStorage.getItem("token");






  const { makeRequest: getProfile } = useRequest("/users/profile", "GET", {
    Authorization: `Bearer ${userToken}`,
  });
  const { makeRequest: getMetrics } = useRequest("/customers/metric", "GET", {
    Authorization: `Bearer ${userToken}`,
  });
  const { makeRequest: getCustomers } = useRequest("/customers", "GET");


  useEffect(() => {
    const fetchProfile = async () => {
      const [response] = await getProfile();
      if (response.status) {
        setProfile(response.data?.user);
      }
    };
    fetchProfile();
  }, []);



    function updateUrlParams(params: { [key: string]: string | number | null }) {
      const url = new URL(window.location.href);
  
      Object.keys(params).forEach((key) => {
        if (params[key]) {
          url.searchParams.set(key, params[key]!.toString());
        } else {
          url.searchParams.delete(key);
        }
      });
  
      window.history.pushState({}, "", url.toString());
    }
  
    useEffect(() => {
        updateUrlParams({
          page: currentPage !== 1 ? currentPage : null,
        });
        fetchCustomers();
      
    }, [ currentPage]);
  
    async function fetchCustomers() {
      const page = currentPage;
      const limit = itemsPerPage;
  
      const [response] = await getCustomers(undefined, {
      
        limit,
        page,
      });
  
      setCustomer(response.data?.customers?.docs);
      setTotalPages(Math.ceil(response.data?.customers?.totalPages));
    }
  

  useEffect(() => {
    const fetchMetrics = async () => {
      const [response] = await getMetrics();
      if (response.status) {
        setMetrics(response.data);
      }
    };
    fetchMetrics();
  }, []);



  useEffect(() => {
    updateUrlParams({
      page: currentPage !== 1 ? currentPage : null,
    });
    fetchCustomers();
  }, [currentPage]);



  function closeCustomerModal() {
    setCustomerModal(false);
  }

  function openCustomerModal() {
    setCustomerModal(true);
  }

  async function handlePageChange(page: number) {
    setCurrentPage(page);
    await fetchCustomers();
  }

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
     <Navbar profile={profile as ProfileData} />
      <main className="flex-1 container mx-auto py-6">
        <div className="flex flex-col sm:flex-row sm:items-center justify-between mb-6">
          <div className="mb-4 sm:mb-0">
            <h1 className="text-[30px] font-extrabold text-black">Customers</h1>
            <p className="text-[#676767] text-[18px] font-normal">
              Manage your B2B and B2C customer relationships
            </p>
          </div>
          <div className="flex gap-2">
            <button className="rounded-full border p-2">Import</button>
          
            <Button
                size="lg"
                variant="primary"
                type="button"
                className="font-normal md:mt-0 mt-6"
                onClick={openCustomerModal}
              >
                <Plus /> Add Customer
              </Button>
          </div>
        </div>
        {metrics && <StatisticsCard metrics={metrics} />}

        <Customer data={customer} />

        {totalPages > 1 && (
          <div className="-4">
            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={handlePageChange}
            />
          </div>
        )}
      </main>
        <AddCustomerDialog  isVisible={customerModal} onClose={closeCustomerModal} />
    </div>
  );
};

export default Customers;
